<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Academic Courses'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Academic Courses'
        };
    },

    computed: {
        labels() {
            return [
                {
                    value: 'number',
                    width: '150px',
                    type: 'number'
                },
                { value: 'name', width: '150px' },
                {
                    value: 'filesCount',
                    type: 'number',
                    width: '150px',
                    filterable: false,
                    sortFieldName: 'filesCount'
                },
                {
                    value: 'creator.fullName',
                    sortFieldName: 'creator.firstName',
                    text: 'Creator',
                    width: '150px'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'academicCourses/index',
            deleteItem: 'academicCourses/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/academic-courses/${id}/edit`);
        },

        onAddButtonClick() {
            this.$router.push('/academic-courses/add');
        }
    }
};
</script>
